import React from "react";
import { ReactComponent as AboutMe } from '../assets/aboutme.svg';
import cvPdf from '../assets/CVEmirhan_Güngör.pdf';

function About() {
  return (
    <section className="py-16" >
      <div className="container mx-auto flex flex-col md:flex-row items-center text-center md:text-left" >
        {/* About Image */}
        <div className="md:w-1/2 mb-8 md:mb-0 flex justify-center">
          <AboutMe className="w-2/3 md:w-3/4 lg:w-1/2" />
        </div>

        {/* About Text */}
        <div className="md:w-1/2 md:pl-8" id="about" style={{ paddingTop: '72px' }}>
          <p className="text-lg text-gray-600 mb-2" >Who Am I?</p>
          <h2 className="text-3xl font-bold mb-4">About Me</h2>
          <p className="text-gray-700 mb-4 font-[500]">
During my university years, I focused on developing my skills in both frontend and full-stack
development. I have worked with technologies like React, Tailwind CSS, Node.js and
Express.js, building responsive, scalable and user-friendly web applications. I enjoy solving
challenges          </p>
          <a
            href={cvPdf} 
            target="_blank" 
            rel="noopener noreferrer" 
            > 
          <button className="rounded btn btn-outline-primary mt-4 p-4 text-white hover:text-gray-200 bg-[#313131] hover:bg-[#616161] duration-300">
            View CV
          </button>
            </a>
        </div>
      </div>
    </section>
  );
}

export default About;
